import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { useQueryClient } from '@tanstack/react-query';

type QueryHelper = {
  excludePeople: (candidateIds: number[]) => void;
  invalidatePeople: (options?: { refetch: boolean }) => void;
  invalidateCandidate: (id: number) => void;
};

const useQueryHelper = (): QueryHelper => {
  const { setValue, getValues } = useFormContext();
  const queryClient = useQueryClient();

  const excludePeople = (candidateIds: number[]) => {
    const excludedSet = new Set(candidateIds);

    queryClient.setQueriesData<{ rows: { id: number }[]; totalRows: number }>(
      { queryKey: ['people'] },
      (oldData) => {
        if (!oldData) {
          return oldData;
        }
        const filteredRows = oldData.rows.filter(
          (row) => !excludedSet.has(row.id)
        );
        return {
          rows: filteredRows,
          totalRows:
            oldData.totalRows - (oldData.rows.length - filteredRows.length),
        };
      }
    );

    const prevExcludedIds =
      (getValues('excludedIds') as number[] | undefined) ?? [];
    setValue('excludedIds', [
      ...new Set([...prevExcludedIds, ...candidateIds]),
    ]);

    setTimeout(() => {
      queryClient.invalidateQueries({
        queryKey: ['people'],
      });
    }, 0);
  };

  const invalidatePeople = (options?: { refetch: boolean }) => {
    queryClient.invalidateQueries({
      queryKey: ['people'],
      refetchType: options?.refetch === false ? 'none' : 'active',
    });
  };

  const invalidateCandidate = (id: number) => {
    queryClient.invalidateQueries({
      queryKey: ['person', 'panel', id],
    });
  };

  return {
    excludePeople,
    invalidatePeople,
    invalidateCandidate,
  };
};

export default useQueryHelper;
